import { Icon } from '../../models/icon.model';
import { ProductType } from '../../models/product.model';
import { ProductV2, ProductV2Variation } from '../../models/product-v2.model';

export interface CartItem {
  id: string;
  product: ProductV2;
  productType?: ProductType;
  quantity: number;
  selectedVariation?: ProductV2Variation;
  linkedMsisdns?: string[];
  addedAt: number;
  lastModified: number;
}

export interface SidebarHeader {
  icon?: string;
  customIcon?: Icon;
  title: string;
}

export interface SyncStatus {
  inProgress: boolean;
  lastSync: number | null;
  lastError: string | null;
  retryCount: number;
}

// UI state
export interface CartUI {
  isSidebarOpen: boolean;
  sidebarHeader: SidebarHeader;
  loading: boolean;
  urlCartLoading: boolean;
}

export interface CartState {
  items: CartItem[];
  ui: CartUI;
  sync: SyncStatus;
  error: string | null;
  lastUpdated: number | null;
}

export function generateCartItemId(product: ProductV2, selectedVariation?: ProductV2Variation): string {
  const productKey = product.uuid || String(product.id);
  const variationKey = selectedVariation?.uuid || 'no-variation';
  return `${productKey}::${variationKey}`;
}

export function createCartItem(
  product: ProductV2,
  quantity: number,
  selectedVariation?: ProductV2Variation
): CartItem {
  const now = Date.now();
  return {
    id: generateCartItemId(product, selectedVariation),
    product,
    productType: product?.productType,
    quantity,
    selectedVariation,
    addedAt: now,
    lastModified: now
  };
}

export function isSameCartItem(item1: CartItem, item2: CartItem): boolean {
  return item1.id === item2.id;
}

export function findCartItemById(items: CartItem[], itemId: string): CartItem | undefined {
  return items.find(item => item.id === itemId);
}

export function findCartItemByProduct(
  items: CartItem[], 
  product: ProductV2, 
  selectedVariation?: ProductV2Variation
): CartItem | undefined {
  const targetId = generateCartItemId(product, selectedVariation);
  return findCartItemById(items, targetId);
}

export const initialState: CartState = {
  items: [],
  ui: {
    isSidebarOpen: false,
    sidebarHeader: {
      customIcon: { name: 'carrinho', type: 'mondrian-icons' },
      title: 'Carrinho'
    },
    loading: false,
    urlCartLoading: false
  },
  sync: {
    inProgress: false,
    lastSync: null,
    lastError: null,
    retryCount: 0
  },
  error: null,
  lastUpdated: null
};
